import { render } from "./FacesheetComments.vue?vue&type=template&id=2d3c1a61"
import script from "./FacesheetComments.ts?vue&type=script&lang=js&external"
export * from "./FacesheetComments.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__